<template>
  <f7-page id="reg-email-verified" name="reg-email-verified" @page:afterin="afterin">
    <f7-block>
      <div class="text-align-center my-5">
        <div v-if="isVerified === true">
          <img :src="require('@/assets/img/icon/icon-success.svg')"/>
          <div class="b fs-24 text-align-center mt-5" v-html="titleText">
          </div>
        </div>
        <div v-if="isVerified === false">
          <div class="b fs-24 text-align-center mb-md">
            {{ titleText }}
          </div>
          <div class="fs-14 fw-medium text-color-gray mb-xxl" v-html="$t('regis-email-verify-failed-error2', { zoholink:  zohoLink})"></div>
          <img :src="require('@/assets/img/icon/icon-email-failed.svg')" class="mt-xl" />
        </div>
      </div>
      <div class="py-5 view-desktop">
        <span v-if="isVerified === true">
          <f7-button round large fill @click="goToHomePage" >
            <span>{{$t('general-btn-send-money')}}</span>
          </f7-button>
        </span>
        <span v-if="isVerified === false">
          <f7-button round large fill @click="contactCS" class="mb-3">
            <span>{{$t('regis-email-contact-customer-service')}}</span>
          </f7-button>
          <f7-button round large fill @click="goToHomePage" class="color-gray6 text-color-green" >
            <span>{{$t('general-btn-send-money')}}</span>
          </f7-button>
        </span>
      </div>
    </f7-block>

    <f7-toolbar v-if="isVerified == true" position="bottom" no-hairline class="toolbar-with-button view-mobile">
      <f7-button large fill @click="goToHomePage">
          {{$t('general-btn-send-money')}}
      </f7-button>
    </f7-toolbar>

    <f7-toolbar v-else position="bottom" no-hairline class="toolbar-with-stacked-button view-mobile">
      <f7-button large fill @click="contactCS">
          {{$t('regis-email-contact-customer-service')}}
      </f7-button>
      <f7-button class="color-gray6 text-color-green" large fill @click="goToHomePage">
        {{$t('general-btn-send-money')}}
      </f7-button>
    </f7-toolbar>
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    mounted (){
      this.showPreloader();

      const id = this.$f7route.query['id'];
      const evc  = this.$f7route.query['evc'];
      const newEmail = this.$f7route.query['newEmail'];

      this.zohoLink = process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK

      if((id && id.trim() != "") && (evc && evc.trim() != "")){
        this.hidePreloader();

        //this.emailId = id;
        //this.emailEVC = evc;
        this.isChangeEmail = (newEmail && newEmail != '' && newEmail != undefined);

        this.setEmailId(id);
        this.setEmailEVC(evc);
        this.setEmail(newEmail!=undefined?newEmail:'');

        this.activateEVC();
      }else{
        console.log("no params or params invalid")
        this.isVerified = false;

        this.hidePreloader();
      }
    },
    data() {
      return {
        isNextButtonValid   : true,
        isVerified          : "",
        isChangeEmail       : false,
        //emailId             : "",
        //emailEVC            : "",
        titleText           : "",
        zohoLink            : "",
      };
    },
    methods: {
      ...mapActions('registration', [
            'setEmail',
            'setEmailId',
            'setEmailEVC'
        ]),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async activateEVC(){
        this.showPreloader();
        const activateEVCPromise = await this.$api.registration.activateEVC();
        if(activateEVCPromise.status == "WN00103" || activateEVCPromise.status == "WN00122" || activateEVCPromise.status == "WN00136"){
          this.isVerified = true;
          this.titleText = this.$t('email-activation-success', {status: this.isChangeEmail?'changed!':'verified!'})

          if(activateEVCPromise.status == "WN00136"){
            this.titleText = this.$t('email-activation-error-already-activated')
          }
        }else{
          this.isVerified = false;

          if(activateEVCPromise.status == "WN00137"){
            this.titleText = this.$t('email-activation-error-expired')
          }else if(activateEVCPromise.status == "4937"){
            this.titleText = this.$t('email-activation-cust-not-found', { zoholink:  this.zohoLink})
          }else{
            this.titleText = this.$t('regis-email-verify-failed-error')
          }
        }

        this.hidePreloader();
      },

      goToHomePage(){
        this.showPreloader();
        this.$f7router.navigate("/home", {force: true, clearPreviousHistory: true});
        this.hidePreloader();
      },

      contactCS(){
        window.location.href = process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK;
      },
    },
    components: {

    },
    computed: {
      ...mapGetters('registration', [
          'emailId',
          'emailEVC',
        ]),
    },
  }
</script>